module.exports = __webpack_public_path__ + "img/oms.c544fde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/oms.png
// module id = Nroj
// module chunks = 8